import React, { useState } from "react";
import BootstrapAlert from "react-bootstrap/Alert";
import "./alert.scss";

const Alert = ({ heading, message, showAlert, handleDismissible, variant }) => {
    if (showAlert) {
        return (
            <BootstrapAlert
                variant={variant}
                onClose={handleDismissible}
                dismissible
            >
                <BootstrapAlert.Heading>{heading}</BootstrapAlert.Heading>
                <p>{message}</p>
            </BootstrapAlert>
        );
    }
};

export default Alert;
